import { useState, useEffect, CSSProperties } from 'react'
import { useParams } from 'react-router-dom';
import * as web3 from "@solana/web3.js"

import { useProgram } from "../utils/ProgramContext";
import { useConnection, useWallet } from "@solana/wallet-adapter-react";
import { Provider } from '../models/Provider';
import { ProviderAdRelation } from '../models/ProviderAdRelation';
import { AdCampaign } from '../models/AdCampaign';


const styles: { [key: string]: CSSProperties } = {
	list: {
		padding: 0,
		listStyleType: 'none',
	},
	listItem: {
		margin: '10px 0',
		padding: '15px',
		borderRadius: '8px',
		boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
		border: '1px solid rgba(0, 0, 0, 0.1)',
		backgroundColor: '#fff',
	},
	name: {
		fontWeight: 'bold',
		marginBottom: '10px',
	},
	checkbox: {
		marginRight: '10px',
	},
};


const ApplyForProviders = () => {

	const { connection } = useConnection()
	const [providers, setProviders] = useState<Provider[]>([])
	const [selectedProviders, setSelectedProviders] = useState<web3.PublicKey[]>([])
	const [adCampaignPda, setAdCampaignPda] = useState<web3.PublicKey>()
	const [adCampaign, setAdCampaign] = useState<AdCampaign>()
	const { program } = useProgram() || {}
	const { publicKey, sendTransaction } = useWallet()
	const { id } = useParams()


	useEffect(() => {
		async function getAccounts() {
			if (!program) {
				return
			}
			const accounts = await program.account.provider.all()
			if (!accounts) {
				return
			}
			const res = []
			for (const account of accounts) {
				if (account) {
					res.push(new Provider(account.account.id as number, account.account.name as string, account.account.location as string, account.publicKey))
				}
			}
			setProviders(res)
		}
		getAccounts()
	}, [program])


	useEffect(() => {
		async function setPda() {
			if (!program || !publicKey || !id) {
				return
			}
			const [adCampaignPda] = await AdCampaign.findAddress(publicKey, parseInt(id))
			const account = await program.account.adCampaign.fetch(adCampaignPda);
			setAdCampaignPda(adCampaignPda)
			setAdCampaign(new AdCampaign(account.id as number, account.name as string, account.link as string))

		}

		setPda()

	}, [program, publicKey, id])

	const handleCheckboxChange = (providerPublicKey: web3.PublicKey, isChecked: boolean) => {
		if (isChecked) {
			setSelectedProviders(prevSelected => [...prevSelected, providerPublicKey]);
		} else {
			setSelectedProviders(prevSelected => prevSelected.filter(pk => pk !== providerPublicKey));
		}
	};

	const handleSubmit = async () => {

		if (!program || !publicKey || !adCampaignPda || !id) {
			return
		}

		const instructionsPromises = selectedProviders.map(providerKey => {
			return { pk: providerKey, relationPda: ProviderAdRelation.findAddress(providerKey, adCampaignPda)[0] }
		}).map(({ pk, relationPda }) => {
			return program.methods
				.createApplicationToProvider(
					pk,
					id
				).accounts({
					providerAdCampaignRelation: relationPda,
					adCampaign: adCampaignPda,
					authority: publicKey,
					systemProgram: web3.SystemProgram.programId
				}).instruction();
		});

		const transaction = new web3.Transaction();
		Promise.all(instructionsPromises).then(instructions => {
			instructions.forEach(instruction => transaction.add(instruction));
		})
		try {
			const txid = await sendTransaction(transaction, connection);
			alert(
				`Transaction submitted: https://explorer.solana.com/tx/${txid}?cluster=devnet`
			);
			console.log(
				`Transaction submitted: https://explorer.solana.com/tx/${txid}?cluster=devnet`
			);
		} catch (e) {
			console.log(JSON.stringify(e));
			alert(JSON.stringify(e));
		}
	}

	return (
		<main className="flex flex-1 flex-col gap-4 p-4 lg:gap-6 lg:p-6">
			<div className="flex items-center">
				<h1 className="text-lg font-semibold md:text-2xl">Available Providers</h1>
			</div>
			<div className="flex flex-1 items-center justify-center rounded-lg border border-dashed shadow-sm">
				<div className="flex flex-col items-center gap-1 text-center">
					{adCampaign && <div>

						<h1>{adCampaign.name}</h1>
						<ul style={styles.list}>
							{providers.map((provider, index) => (
								<li key={index} style={styles.listItem}>
									<input
										type="checkbox"
										style={styles.checkbox}
										checked={selectedProviders.includes(provider.publicKey || new web3.PublicKey(""))}
										onChange={(e) => handleCheckboxChange(provider.publicKey || new web3.PublicKey(""), e.target.checked)}
									/>
									{provider.name}
								</li>
							))}
						</ul>
						<button className={"m-5 bg-black hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"} onClick={() => handleSubmit()}>Apply</button>
					</div>
					}
				</div>
			</div>
		</main>
	);
};

export default ApplyForProviders;

